import React, { useEffect } from "react";
import { Modal, Form, Input, Select, message } from "antd";
import { Hospital } from "../../models/Hospital";
import { createTable, isSchoolCodeExist } from "../../api/Api";
import { School } from "../../models/School";
import { loginInfo } from "../../config";
import { useHistory } from "react-router-dom";

interface PropsType {
  visible: boolean;
  add: Function;
  setInvisible: Function;
  hospital: Hospital;
}
export const AddSchool: React.FC<PropsType> = ({
  visible,
  add,
  setInvisible,
  hospital,
}) => {
  const [form] = Form.useForm();
  const history = useHistory();
  useEffect(() => {
    form.setFieldsValue({ hospitalName:hospital.hospitalName,code: "", name: "" });
  }, [visible, form]);

  const handlerOk = async () => {
    const code: any = form.getFieldValue("code");
    const name: any = form.getFieldValue("name");
    if (typeof code === "undefined" || typeof name === "undefined") {
      message.warning("学校名称和代码不能为空!");
      return;
    }
    if (code.length !== 5) {
      message.warning("学校代码必须是5位字母或数据!");
      return;
    }
    if (await isSchoolCodeExist(hospital.id,code)) {
      message.warning("学校代码已存在,请修改学校代码.");
      return;
    }
    let school: School = {
      id: -1,
      key: -1,
      schoolName: name,
      schoolCode: code,
      hospitalId: hospital.id,
      hospitalName: hospital.hospitalName,
    };
    let data = await createTable("school", school);
    if(typeof data === "undefined"){
      history.push("/");      
    }
    add(data);
    setInvisible();
  };
  const handlerCancel = () => {
    setInvisible();
  };

  return (
    <>
      <Modal
        forceRender={true}
        title="增加学校"
        visible={visible}
        onOk={handlerOk}
        onCancel={handlerCancel}
        okText="保存"
        cancelText="取消"
      >
        <Form
          form={form}
          name="schooladd"
          layout="horizontal"
          labelCol={{ span: 14 }}
          wrapperCol={{ span: 10 }}
        >
          <Form.Item name="hospitalName" label="医院">
            <Input readOnly={true} />
          </Form.Item>

          <Form.Item
            name="name"
            label="学校名称"
            rules={[
              {
                required: true,
                message: "学校名称不能为空",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="code"
            label="学校代码"
            rules={[
              {
                required: true,
                len: 5,
                message: "学校代码为5个字符,可以包括字母和数字",
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};
